import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "recorder" }
const _hoisted_2 = {
  ref: "container",
  class: "wave"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_Loader = _resolveComponent("Loader")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, null, 512 /* NEED_PATCH */), [
      [_vShow, $data.recording]
    ]),
    (!$options.active)
      ? (_openBlock(), _createBlock(_component_Tooltip, {
          key: 0,
          text: "Dictate"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              icon: "microphone-01",
              "stroke-width": "1",
              width: "2rem",
              height: "2rem",
              stroke: "#717680",
              class: "pointer",
              hoverable: "",
              onClick: $options.start
            }, null, 8 /* PROPS */, ["onClick"])
          ]),
          _: 1 /* STABLE */
        }))
      : ($data.recording)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_Icon, {
              icon: "x",
              stroke: "#717680",
              width: "2rem",
              height: "2rem",
              class: "pointer",
              onClick: $options.cancel
            }, null, 8 /* PROPS */, ["onClick"]),
            _createVNode(_component_Icon, {
              icon: "check",
              stroke: "var(--success-600)",
              width: "2rem",
              height: "2rem",
              class: "pointer",
              onClick: $options.confirm
            }, null, 8 /* PROPS */, ["onClick"])
          ], 64 /* STABLE_FRAGMENT */))
        : ($data.sending)
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 2,
              inline: "",
              small: "",
              tiny: ""
            }))
          : _createCommentVNode("v-if", true)
  ]))
}